import Axios from 'axios';
import { action, observable, computed } from 'mobx';
import { OrderParams, PageInfo, ScrollPageInfo } from '@/models/data';
import { Notification } from 'element-react';
import { API } from '@/config/api';
import i18n from '@/i18n';
import { getBaseUrlBySymbol, getBaseUrlByUnderlyingType } from '@/utils/futures';
import UnderLyingEnum from '@/@enums/UnderLyingEnum';
import Cookies from 'js-cookie';
import qs from 'qs';
import { number } from 'echarts';
import OtcConsumer from './otcConsumer';

export interface CreatInfoItem {
  id: string;
  totalAmount: number;
  singleLimitMax: number;
  singleLimitMin: number;
  direction: string;
  currencyCoin: string;
  coinType: string;
}
export interface Levels {
  amount: number;
  limit: number;
  coinType: string;
  name: string;
}
export interface OtcInfo {
  levels: Levels[];
  merchant: boolean;
  name: string;
  otcAuth: boolean;
  direction: string;
  tel: string;
  telCountryCode: string;
  payMethods: [];
  registeredDays: number;
  completedOrders: number;
  completion: number;
  kyc: boolean;
  allOrders: number | string;
}
export interface MerchantInfo {
  address: string;
  addressImage: string;
  authImage: string;
  authVideo: string;
  email: string;
  emergencyName: string;
  emergencyTel: string;
  freezeAmount: number;
  freezeCoin: string;
  hkbImage: string;
  id: number;
  level: string;
  name: string;
  nickName: string;
  reason: string;
  relation: string;
  status: number;
  tel: string;
  userId: string;
  wechat: string;
  registeredTime: number;
}
export interface AvInfo {
  totalAmount: string;
  priceType: number;
  singleLimitMax: string;
  singleLimitMin: string;
  payMethods: string;
  priceParam: string;
  // 以上必须
  coinType: string;
  currencyCoin: string;
  direction: string;
  registeredDays: string;

  remark: string;
  id: number | string;
}
export interface OtcFlowPageInfo {
  page: number;
  size: number;
  totalCount: number;
}

// const { coinType, currencyCoin,priceParam, direction, remark,id, singleLimitMax, singleLimitMin, totalAmount, priceType, } = advInfo;
export default class Order {
  @observable sellList: any[];

  @observable flowList: any[];

  @observable otcInfo: OtcInfo;

  @observable merchantInfo: MerchantInfo;

  @observable myOrderList: any;

  @observable myOrderListInfo: any;

  @observable creatInfo: CreatInfoItem;

  @observable updateAdvInfo: CreatInfoItem;

  @observable sellListPageInfo: PageInfo;

  @observable otcListPageInfo: PageInfo;

  @observable flowListPageInfo: ScrollPageInfo;

  @observable isFetchingSellList: boolean;

  @observable isFetchingOrderList: boolean;

  @observable isFetchingFlowList: boolean;

  @observable applyModalVisible: boolean;

  @observable confirmModalVisible: boolean;

  @observable paymentModalVisible: boolean;

  @observable toAuthModalVisible: boolean;

  @observable paymentList: [];

  @observable advInfo: AvInfo;

  @observable merchantAdvInfo: AvInfo;

  @observable supportCoinTypesList: []; // 支持的币种

  @observable supportCurrencyCoinsList: []; // 支持的法币

  @observable otcBillTypes: any[]; // 流水类型

  constructor() {
    this.merchantInfo = {
      address: '',
      addressImage: '',
      authImage: '',
      hkbImage: '',
      authVideo: '',
      email: '',
      emergencyName: '',
      emergencyTel: '',
      freezeAmount: 0,
      freezeCoin: '',
      id: 0,
      level: '',
      name: '',
      nickName: '',
      reason: '',
      relation: '',
      status: -1,
      tel: '',
      userId: '',
      wechat: '',
      registeredTime: 0,
    };
    this.otcInfo = {
      levels: [{ amount: 0, limit: 0, coinType: '', name: '' }],
      merchant: false,
      name: '',
      otcAuth: false,
      direction: '',
      tel: '',
      telCountryCode: '',
      payMethods: [],
      registeredDays: 0,
      completedOrders: 0,
      completion: 0,
      kyc: false,
      allOrders: 0,
    };
    this.advInfo = {
      registeredDays: '',
      coinType: '',
      currencyCoin: '',
      direction: '',
      id: '',
      singleLimitMax: '',
      singleLimitMin: '',
      totalAmount: '',
      priceType: 1,
      payMethods: '',
      remark: '',
      priceParam: '',
    };
    this.merchantAdvInfo = {
      registeredDays: '',
      coinType: '',
      currencyCoin: '',
      direction: '',
      id: '',
      singleLimitMax: '',
      singleLimitMin: '',
      totalAmount: '',
      priceType: 1,
      payMethods: '',
      remark: '',
      priceParam: '',
    };
    this.advInfo = {
      registeredDays: '',
      coinType: '',
      currencyCoin: '',
      direction: '',
      id: '',
      singleLimitMax: '',
      singleLimitMin: '',
      totalAmount: '',
      priceType: 1,
      payMethods: '',
      remark: '',
      priceParam: '',
    };
    this.merchantAdvInfo = {
      registeredDays: '',
      coinType: '',
      currencyCoin: '',
      direction: '',
      id: '',
      singleLimitMax: '',
      singleLimitMin: '',
      totalAmount: '',
      priceType: 1,
      payMethods: '',
      remark: '',
      priceParam: '',
    };
    this.sellList = [];
    this.myOrderList = [];
    this.myOrderListInfo = [];
    this.creatInfo = {
      id: '',
      totalAmount: 0,
      singleLimitMin: 0,
      singleLimitMax: 0,
      direction: '',
      currencyCoin: '',
      coinType: '',
    };
    this.updateAdvInfo = {
      id: '',
      totalAmount: 0,
      singleLimitMin: 0,
      singleLimitMax: 0,
      direction: '',
      currencyCoin: '',
      coinType: '',
    };
    this.sellListPageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.otcListPageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.flowListPageInfo = {
      hasPrev: false,
      hasNext: false,
    };
    this.isFetchingSellList = false;
    this.isFetchingOrderList = false;
    this.isFetchingFlowList = false;
    this.applyModalVisible = false;
    this.confirmModalVisible = false;
    this.paymentModalVisible = false;
    this.toAuthModalVisible = false;
    this.paymentList = [];
    this.supportCoinTypesList = [];
    this.supportCurrencyCoinsList = [];
    this.flowList = [];
    this.otcBillTypes = [];
  }

  @computed get levelsList() {
    const { levels } = this.otcInfo;
    return levels;
  }

  @action.bound
  setPaymentList(data: any) {
    this.paymentList = data;
  }

  @action.bound
  setFlowList(data: any) {
    this.flowList = data;
  }

  @action.bound
  setAdvInfo(data: any) {
    this.advInfo = data;
  }

  @action.bound
  setMerchantAdvInfo(data: any) {
    this.merchantAdvInfo = data;
  }

  @action.bound
  setSupportCoinList(data: any) {
    const { coinTypes, currencyCoins, currencyCoinDisplay } = data;
    this.supportCoinTypesList = coinTypes;
    this.supportCurrencyCoinsList = currencyCoins;
  }

  @action.bound
  setApplyModalVisible(data: boolean) {
    this.applyModalVisible = data;
  }

  @action.bound
  setConfirmModalVisible(data: boolean) {
    this.confirmModalVisible = data;
  }

  @action.bound
  setOtcBillTpye(data: any) {
    this.otcBillTypes = data;
  }

  @action.bound
  setPaymentModalVisible(data: boolean) {
    this.paymentModalVisible = data;
  }

  @action.bound
  setToAuthModalVisible(data: boolean) {
    this.toAuthModalVisible = data;
  }

  @action.bound
  setLoadingState(key: string, data: boolean) {
    // @ts-ignore
    this[key] = data;
  }

  @action
  setCreatInfo(data: any) {
    this.creatInfo = data;
  }

  @action
  setUpdateAdvInfo(data: any) {
    this.updateAdvInfo = data;
  }

  @action
  setMerchantInfo(data: any) {
    this.merchantInfo = data;
  }

  @action
  setMyOrderList(data: any[]) {
    this.myOrderList = data;
  }

  @action
  setOtcInfo(data: any) {
    this.otcInfo = data;
  }

  @action
  setMyOrderListInfo(data: any) {
    this.myOrderListInfo = data;
  }

  @action
  setSellList(data: any[]) {
    this.sellList = data;
  }

  @action.bound
  setSellListPageInfo(data: PageInfo) {
    const origin = { ...this.sellListPageInfo };
    this.sellListPageInfo = { ...origin, ...data };
  }

  @action.bound
  setOrderistPageInfo(data: PageInfo) {
    const origin = { ...this.otcListPageInfo };
    this.otcListPageInfo = { ...origin, ...data };
  }

  @action.bound
  setFlowListPageInfo(data: ScrollPageInfo) {
    const origin = { ...this.flowListPageInfo };
    this.flowListPageInfo = { ...origin, ...data };
  }

  // 我的订单
  @action.bound
  async fetchMyOrderList(params: { page?: number; size?: number }) {
    this.setLoadingState('isFetchingOrderList', true);
    const otcListPageInfo = this.otcListPageInfo;
    const config: any = {
      params: {
        page: otcListPageInfo.page,
        size: otcListPageInfo.size,
        ...params,
      },
    };

    const result: any = await Axios.get(API.OTC_ORDER_LIST, config).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });

    if (result) {
      const {
        data,
        pageRequest: { page, size },
        total,
      } = result;
      this.setMyOrderList(data);
      this.setOrderistPageInfo({ page, size, total });
    }
    this.setLoadingState('isFetchingOrderList', false);

    return Promise.resolve(result);
  }

  // 订单详情
  @action.bound
  async fetchMyOrderListInfo(data: any) {
    const result: any = await Axios.post(API.OTC_ORDER_INFO, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });

    if (result) {
      this.setMyOrderListInfo(result);
    }
    return Promise.resolve(result);
  }

  // 撤单
  @action.bound
  async fetchOrderCancel(data: any) {
    const result: any = await Axios.post(API.OTC_CANCEL, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    this.fetchMyOrderList();
    return Promise.resolve(result);
  }

  // 确认付款
  @action.bound
  async fetchConfirmPayment(data: any) {
    const result: any = await Axios.post(API.OTC_COMFIRM_PAYMENT, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    this.fetchMyOrderList();
    return Promise.resolve(result);
  }

  // 确认放币
  @action.bound
  async fetchConfirmReceipt(data: any) {
    const result: any = await Axios.post(API.OTC_COMFIRM_RECEIPT, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    this.fetchMyOrderList({ page: 1, size: 10 });
    return Promise.resolve(result);
  }

  // 广告列表
  @action.bound
  async fetchSellList(params?: {
    page?: number;
    size?: number;
    statue?: string;
    direction?: string;
    coinType?: string;
  }) {
    this.setLoadingState('isFetchingSellList', true);
    const sellListPageInfo = this.sellListPageInfo;
    const config: any = {
      params: {
        page: sellListPageInfo.page,
        size: sellListPageInfo.size,
        ...params,
      },
    };

    const result: any = await Axios.get(API.OTC_SELL_LIST, config);

    if (result) {
      const {
        data,
        pageRequest: { page, size },
        total,
      } = result;

      this.setSellList(data);
      this.setSellListPageInfo({ page, size, total });
    }

    this.setLoadingState('isFetchingSellList', false);
  }

  // 新增广告
  @action.bound
  async fetchAddAdv(data: any) {
    const result: any = await Axios.post(API.OTC_ADD_ADV, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });

    if (result) {
      this.setCreatInfo(result);
    }
    return Promise.resolve(result);
  }

  // 上架广告
  @action.bound
  async fetchPublishAdv(data: any) {
    const result: any = await Axios.post(API.OTC_PUBLISH_ADV, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });

    if (result) {
      Notification.success({
        message: i18n.t('common.listingSuccess'),
        offset: 60,
        duration: 2000,
      });
      this.fetchSellList();
    }
  }

  // 修改广告
  @action.bound
  async fetchUpdateAdv(data: any) {
    const result: any = await Axios.post(API.OTC_NOD_ADV, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });

    if (result) {
      Notification.success({
        message: i18n.t('common.modifiedSuccess'),
        offset: 60,
        duration: 2000,
      });
      this.setUpdateAdvInfo(result);
      return Promise.resolve(result);
    }
  }

  // 用户版广告详情
  @action.bound
  async fetchAdvInfo(id?: string) {
    const result: any = await Axios.get(API.OTC_ADV_INFO, { params: { id } }).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });

    if (result) {
      this.setAdvInfo(result);
    }
  }
  //   // 商家版广告详情

  @action.bound
  async fetchMerchantAdvInfo(id?: string) {
    const result: any = await Axios.get(API.OTC_MARCHANT_AD_INFO, { params: { id } }).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });

    if (result) {
      this.setMerchantAdvInfo(result);

      // Notification.success({
      //   message: i18n.t('common.modifiedSuccess'),
      //   offset: 60,
      // });
    }
  }

  // 下架广告
  @action.bound
  async fetchSoldOutAdv(data: any) {
    const result: any = await Axios.post(API.OTC_SOLD_ADV, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });

    if (result) {
      Notification.success({
        message: i18n.t('common.removeSuccess'),
        offset: 60,
        duration: 2000,
      });
      this.fetchSellList();
    }
  }

  // 删除广告
  @action.bound
  async fetchDelAdv(data: any) {
    const result: any = await Axios.post(API.OTC_DEL_ADV, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      Notification.success({
        message: i18n.t('common.delSuccess'),
        offset: 60,
        duration: 2000,
      });
      this.fetchSellList();
    }
  }

  // 绑定收付款
  @action.bound
  async fetchReceipt(data: any) {
    const result: any = await Axios.post(API.OTC_SET_RECE, data).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });

    if (result) {
      Notification.success({
        message: i18n.t('common.bindSuccess'),
        offset: 60,
        duration: 2000,
      });
      this.fetchOtcInfo();
      new OtcConsumer().fetchGetReceipt();
      return Promise.resolve(result);
    }
  }

  @action.bound
  async fetchApply(data) {
    const result: any = await Axios.post(API.OTC_APPLY, data).catch(({ error }: any) => {
      Notification.error({
        message: error || i18n.t('failure.order'),
        offset: 60,
        duration: 2000,
      });
    });

    if (result) {
      Notification.success({
        message: i18n.t('common.submitSuccess'),
        offset: 60,
        duration: 2000,
      });
      this.fetchMerchantInfo();

      return Promise.resolve(result);
    }
  }

  @action.bound
  async fetchOtcInfo() {
    const result: any = await Axios.get(API.OTC_INFO).catch(({ error }: any) => {
      Notification.error({
        message: error || i18n.t('failure.order'),
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      this.setOtcInfo(result);
    }
  }

  // 、、获取商家信息
  @action.bound
  async fetchMerchantInfo() {
    const result: any = await Axios.get(API.OTC_GET_MARCHANT);
    if (result) {
      this.setMerchantInfo(result);
    }
  }

  @action.bound
  async fetchCheckNickname(data) {
    const result: any = await Axios.post(API.OTC_CHECK_NAME, qs.stringify(data));
    if (result) {
      return Promise.resolve(result);
    }
  }

  // 、、广告支持币种
  @action.bound
  async fetchSupportCoin() {
    const result: any = await Axios.get(API.OTC_AD_SUPP);
    if (result) {
      this.setSupportCoinList(result);
    }
  }

  // 资金流水
  @action.bound
  async fetchFlowList(params?: {
    page?: number;
    size?: number;
    coinType?: string;
    id?: string;
    type?: string;
    direction?: ScrollPaginationDirection;
    limit?: number;
    startTime?: string | number | undefined;
    endTime?: string | number | undefined;
  }) {
    this.setLoadingState('isFetchingFlowList', true);

    const config: any = {
      params: {
        ...params,
      },
    };

    const result: any = await Axios.get(API.OTC_HISTOTY_LIST, config).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });

    if (result) {
      const { items, hasPrev, hasNext } = result;
      this.setFlowList(items);

      this.setFlowListPageInfo({ hasPrev, hasNext });
    }
    this.setLoadingState('isFetchingFlowList', false);

    return Promise.resolve(result);
  }

  // 资金流水类型
  @action.bound
  async fetchBillType() {
    const result: any = await Axios.get(API.OTC_CONF_ALL);

    if (result) {
      this.setOtcBillTpye(result);
    }
  }
}
